import customerUserRelationshipsService from './customerUserRelationshipsService'

export default customerUserRelationshipsService



// WEBPACK FOOTER //
// ../src/services/customerUserRelationshipsService/index.js